/**
 * useTranslation Hook
 */
import { useCallback } from 'react';
import { getTranslation } from '../i18n';
import type { SupportedLanguage } from '../types';

interface UseTranslationReturn {
  t: (key: string, variables?: Record<string, string | number>) => string;
  language: SupportedLanguage;
}

export const useTranslation = (language: SupportedLanguage = 'en'): UseTranslationReturn => {
  const t = useCallback(
    (key: string, variables: Record<string, string | number> = {}) => getTranslation(language, key, variables),
    [language]
  );

  return { t, language };
};

export default useTranslation;
